import type { EtapaDaEsteira } from "./implantacoes";

const TEXTOS: Record<EtapaDaEsteira["etapa"], { explicacao: string; proxima: string | null }> = {
  contrato: {
    explicacao: "Seu contrato foi registrado e o seu acesso ao portal foi criado. Aqui ficam o contrato assinado, os módulos e os Recursos Plus contratados.",
    proxima: "Dados de infraestrutura",
  },
  infraestrutura: {
    explicacao: "Você envia os dados do servidor e do banco do ERP. Nossa equipe de infraestrutura confere os acessos, prepara o ambiente e valida a conexão com o seu ERP.",
    proxima: "Kickoff dos módulos",
  },
  kickoff: {
    explicacao: "Você responde as perguntas de cada módulo contratado. Nossa equipe analisa as respostas para preparar a reunião de kickoff.",
    proxima: "Reunião de kickoff",
  },
  reuniao: {
    explicacao: "Nesta reunião a nossa consultora revisa com você as respostas do kickoff e alinha os detalhes de cada módulo antes de começar a integração. A data e o link estão na Agenda.",
    proxima: "Execução e virada",
  },
  execucao: {
    explicacao: "Cada módulo contratado segue o seu próprio caminho: integração, treinamento e acompanhamento. Clique em um módulo para ver o que está acontecendo nele.",
    proxima: null,
  },
};

export function textoDaEtapaDoCliente(etapa: EtapaDaEsteira["etapa"]) {
  return TEXTOS[etapa];
}
